import React from "react";
import { Row, Col, PanelGroup, Tab, Nav, NavItem, FormControl, FormGroup } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { MyContext } from "../context";
import { notify } from "react-notify-toast";
import { Header, Loader, Images, ComingSoon, NoDataScreen, SubHeader, LeaderboardBracket } from "../components";
import InfiniteScroll from "react-infinite-scroll-component";
import Slider from "react-slick";
import _ from "lodash";
import MetaData from "../helper/MetaData";
import WSManager from "../helper/WSManager";
import * as NC from "../helper/NetworkingConstants";
import * as Constants from "../helper/Constants";
import LeaderBoardRecord from "./LeaderBoardRecord";
import RPLFinalTab from "./RPLFinalTab";

const FIFA_LEAGUE_OPTION = { value: "fifa-world-cup-2026", label: "FIFA World Cup 2026" };
const LEADERBOARD_EXTRA_LEAGUE_OPTIONS = [FIFA_LEAGUE_OPTION];
const FIFA_GROUP_FILTERS = "ABCDEFGHIJKL".split("");
const FIFA_JOURNEY_ROUND_SLOTS = {
  quarter: [
    { winnerSlot: "q1", playerSlots: ["b1", "b2"] },
    { winnerSlot: "q2", playerSlots: ["r1", "r2"] },
    { winnerSlot: "q3", playerSlots: ["r3", "r4"] },
    { winnerSlot: "q4", playerSlots: ["b3", "b4"] }
  ],
  semi: [
    { winnerSlot: "semi-left", playerSlots: ["q1", "q2"] },
    { winnerSlot: "semi-right", playerSlots: ["q3", "q4"] }
  ],
  final: [
    { winnerSlot: "winner", playerSlots: ["semi-left", "semi-right"] }
  ]
};
const FIFA_JOURNEY_BRACKET_SLOTS = [
  { id: "winner", x: 50, y: 8, status: "winner" },
  { id: "semi-left", x: 18, y: 25 },
  { id: "semi-right", x: 82, y: 25 },
  { id: "q1", x: 10, y: 42 },
  { id: "q2", x: 28, y: 42 },
  { id: "q3", x: 72, y: 42 },
  { id: "q4", x: 90, y: 42 },
  { id: "r1", x: 16, y: 62 },
  { id: "r2", x: 32, y: 62 },
  { id: "r3", x: 68, y: 62 },
  { id: "r4", x: 84, y: 62 },
  { id: "b1", x: 10, y: 85 },
  { id: "b2", x: 28, y: 85 },
  { id: "b3", x: 72, y: 85 },
  { id: "b4", x: 90, y: 85 }
];
export default class LeaderBoard extends React.Component {
  constructor(props) {
    super(props);
    this.SearchUserReq = _.debounce(this.SearchUserReq.bind(this), 700);
    this.state = {
      isLoading: false,
      leaderboardResult: [],
      ownLeaderboard: [],
      searchClick: false,
      selectedRound: "",
      selectedLeague: "",
      selectedContest: "",
      selectedMonth: "",
      selectedFormat: "",
      offset: 0,
      hasMore: false,
      Searchkey: "",
      selectedMainTab: 0,
      selectedUserTab: 0,
      selectedRPLCupTab: 0,
      selectedFollowOption: Constants.FollowOption[0],
      selectedFollow: "",
      selectedGrpIDX: 0,
      selectedCategory: Constants.categories[0],
      selectedContestType: "",
      pageBanner: [],
      current_rank: "",
      categories_list: Constants.categories,
      contest_duration_options: Constants.contest_duration,
      selectedContestDuration: Constants.contest_duration[0],
      selectedFifaStage: "",
      selectedFifaGroupIDX: 0
    };
  }

  setRouteParam() {
    if (!_.isUndefined(this.props.location.state)) {
      let lc = this.props.location.state;
      this.setState({
        selectedRound: lc.selectedRound || "",
        selectedLeague: lc.selectedLeague || "",
        selectedContest: lc.selectedContest || "",
        selectedMonth: lc.selectedMonth || "",
        selectedMainTab: lc.selectedLeague.value == "1" || lc.selectedLeague.value == "2" || lc.selectedLeague.value == "4" ||  (lc.selectedContestType && lc.selectedContestType.value == '2') || lc.selectedMainTab == 1 ? 1 : 0,
        // selectedMainTab: (lc.selectedContestType && lc.selectedContestType.value == '2') ? 1 : 0,
        selectedCategory: lc.selectedCategory || Constants.categories[0],
        selectedContestType: lc.selectedContestType || "",
        selectedContestDuration:lc.selectedContestDuration ||  Constants.contest_duration[0]
      });
    }
  }

  componentWillMount() {
    this.setRouteParam();
  }

  componentDidMount() {
    this.initializeLeaderBoard();
    this.getPageBanner()
  }

  getPageBanner = () => {
    let param = {
      page_type_id: Constants.BANNER_PAGE_TYPE_ID.leaderboard,
      position_id: "1"
    }
    WSManager.Rest(NC.baseURL + NC.GET_PAGE_BANNER, param)
      .then(res => {
        if (res.response_code === NC.successCode) {
          this.setState({ pageBanner: res.data })
        }
      })
  }

  SearchUserReq() {
    const { Searchkey } = this.state;
    if (Searchkey.trim().length < 2 && Searchkey.trim().length > 0) return;
    this.callLeaderBoardApi();
  }

  getLeaderboardFilterParams = (selectedLeague = this.state.selectedLeague) => {
    const { selectedCategory } = this.state;
    let param = {};

    if (
      selectedCategory !== "" &&
      selectedCategory.hasOwnProperty("id") &&
      selectedLeague.value !== Constants.GLOBAL_LEAGUE
    ) {
      param["type"] = selectedCategory.id;
      param["type_name"] = selectedCategory.name;
      if (selectedCategory.id === "2") {
        param["country_id"] = selectedCategory.value;
      }
      if (selectedCategory.id === "3") {
        param["team_id"] = selectedCategory.value;
      }
    }

    return param;
  };

  getLeagueOption = item => ({
    label: item.name,
    value: item.contest_type_id,
    data: item
  });

  getFifaStageLabel = item => {
    return item.round_name || item.name || item.stage_name || item.label || "";
  };

  getFifaStageOption = item => ({
    label: this.getFifaStageLabel(item),
    value: item.round_id || item.value || item.stage_id,
    data: item
  });

  loadLeaderBoardForLeague = selectedLeague => {
    if (this.isFifaLeagueOption(selectedLeague)) {
      this.getFifaRoundFilters(selectedLeague, true);
      return;
    }
    this.callLeaderBoardApi();
  };

  initializeLeaderBoard = () => {
    if (this.state.selectedLeague) {
      this.loadLeaderBoardForLeague(this.state.selectedLeague);
      return;
    }

    this.getDefaultLeagueFilter();
  };

  getDefaultLeagueFilter = () => {
    this.setState({ isLoading: true });

    WSManager.Rest(
      NC.baseURL + NC.GET_LEADERBOARD_LEAGUE_FILTERS,
      this.getLeaderboardFilterParams()
    )
      .then(responseJson => {
        if (responseJson.response_code === NC.successCode) {
          const leaguesArray = (responseJson.data || []).map(this.getLeagueOption);
          const selectedLeague = leaguesArray[0] || "";

          this.setState(
            {
              selectedLeague: selectedLeague,
              offset: 0,
              hasMore: false
            },
            () => {
              this.loadLeaderBoardForLeague(selectedLeague);
            }
          );
        }
        else {
          this.setState({ isLoading: false });
        }
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  };

  getFifaRoundFilters = (selectedLeague = this.state.selectedLeague, shouldLoadLeaderboard = false) => {
    const { selectedMonth } = this.state;
    const filterParams = this.getLeaderboardFilterParams(selectedLeague);
    const param = {
      ...filterParams,
      month: selectedMonth.value || "",
      contest_type_id: selectedLeague ? selectedLeague.value : "",
      type: filterParams.type || "1"
    };

    this.setState({ isLoading: true });

    WSManager.Rest(NC.baseURL + NC.GET_LEADERBOARD_ROUNDS_FILTERS, param)
      .then(responseJson => {
        if (responseJson.response_code === NC.successCode) {
          const fifaStageOptions = (responseJson.data || []).map(this.getFifaStageOption);

          const selectedFifaStage = fifaStageOptions[0] || "";

          this.setState(
            {
              selectedFifaStage: selectedFifaStage,
              selectedFifaGroupIDX: 0,
              offset: 0,
              hasMore: false
            },
            () => {
              if (shouldLoadLeaderboard) {
                this.callLeaderBoardApi();
              }
              else {
                this.setState({ isLoading: false });
              }
            }
          );
        }
        else {
          this.setState({ isLoading: false });
        }
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  };

  filterAction(selectleague, selectround, selectedContest, selectedMonth, selectedFormat, selectedCategory, selectedFollowOption, selectedContestType, selectedWinner,
    selectedEntryFee, minSize, selectedContestDuration, selectedFifaStage) {
    const fifaStage = selectedFifaStage || this.state.selectedFifaStage;
    this.setState({
      selectedLeague: selectleague,
      selectedRound: selectround,
      selectedContest: selectedContest,
      selectedMonth: selectedMonth,
      selectedFormat: selectedFormat,
      selectedCategory: selectedCategory,
      selectedFollowOption: selectedFollowOption,
      selectedContestType: selectedContestType,
      selectedContestDuration:selectedContestDuration,
      selectedFifaStage: fifaStage,
      selectedFifaGroupIDX: 0,
      offset: 0,
      hasMore: false
    }, () => {
      this.callLeaderBoardApi();
    }
    );
  }

  showScoringRules() {
    Header.showScoringModal();
  }

  showPrizes(e) {
    if (e) {
      e.preventDefault();
    }
    Header.showPrizeModal();
  }
  showStats() {
    this.props.history.push('stats-awards')
  }

  isFifaLeagueOption(option) {
    return option && (
      option.value === FIFA_LEAGUE_OPTION.value ||
      (option.label || "").toLowerCase() === FIFA_LEAGUE_OPTION.label.toLowerCase()
    );
  }

  isFifaWorldCupSelected() {
    return this.isFifaLeagueOption(this.state.selectedLeague);
  }

  getFifaStageValue() {
    const { selectedFifaStage } = this.state;
    return selectedFifaStage && selectedFifaStage.value ? selectedFifaStage.value : "";
  }

  getFifaStageData() {
    const { selectedFifaStage } = this.state;
    return selectedFifaStage && selectedFifaStage.data ? selectedFifaStage.data : {};
  }

  getFifaStageKey() {
    const { selectedFifaStage } = this.state;
    const fifaStageData = this.getFifaStageData();
    if (!selectedFifaStage) {
      return "";
    }
    return `${selectedFifaStage.value || ""} ${selectedFifaStage.label || ""} ${fifaStageData.stage_name || ""} ${fifaStageData.name || ""} ${fifaStageData.round_name || ""} ${fifaStageData.stage_type || ""} ${fifaStageData.round_type || ""} ${fifaStageData.slug || ""}`.toLowerCase();
  }

  isFifaQualificationStage() {
    return this.getFifaStageKey().indexOf("qualification") > -1;
  }

  isFifaGroupStage() {
    return this.getFifaStageKey().indexOf("group") > -1;
  }

  getFifaGroupName = item => {
    const groupName =
      item.group_name ||
      item.group_label ||
      item.group_title ||
      item.group ||
      item.fifa_group_name ||
      item.stage_group_name ||
      item.pool_name ||
      item.pool_label ||
      item.pool_title ||
      item.pool ||
      item.group_no ||
      item.group_number ||
      item.group_index ||
      "";
    if (!groupName) {
      return "";
    }
    const label = String(groupName).trim();
    if (/^\d+$/.test(label)) {
      const groupNumber = parseInt(label, 10);
      if (groupNumber > 0 && groupNumber <= 26) {
        return `Group ${String.fromCharCode(64 + groupNumber)}`;
      }
    }
    return label.toLowerCase().indexOf("group") === 0 ? label : `Group ${label}`;
  };

  getFifaGroupOptions = (users = []) => {
    const groupMap = {};
    (users || []).forEach(item => {
      const groupName = this.getFifaGroupName(item);
      if (groupName && !groupMap[groupName]) {
        groupMap[groupName] = { label: groupName, value: groupName };
      }
    });

    return Object.keys(groupMap)
      .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
      .map(key => groupMap[key]);
  };

  getFifaGroupFilterOptions = () => {
    return FIFA_GROUP_FILTERS.map(groupName => ({
      label: `Group ${groupName}`,
      value: groupName
    }));
  };

  getSelectedFifaGroupOption = () => {
    const groupOptions = this.getFifaGroupFilterOptions();
    return groupOptions[this.state.selectedFifaGroupIDX] || groupOptions[0];
  };

  handleFifaGroupChange = direction => {
    if (this.fifaGroupSlider) {
      if (direction > 0) {
        this.fifaGroupSlider.slickNext();
      }
      else {
        this.fifaGroupSlider.slickPrev();
      }
      return;
    }

    const groupOptions = this.getFifaGroupFilterOptions();
    const selectedFifaGroupIDX =
      (this.state.selectedFifaGroupIDX + direction + groupOptions.length) % groupOptions.length;
    this.handleFifaGroupSlideChange(selectedFifaGroupIDX);
  };

  handleFifaGroupSlideChange = selectedFifaGroupIDX => {
    if (selectedFifaGroupIDX === this.state.selectedFifaGroupIDX) {
      return;
    }

    this.setState(
      {
        selectedFifaGroupIDX: selectedFifaGroupIDX,
        leaderboardResult: [],
        ownLeaderboard: [],
        offset: 0,
        hasMore: false
      },
      this.callLeaderBoardApi
    );
  };

  isFifaH2HStage() {
    const stageKey = this.getFifaStageKey();
    return stageKey.indexOf("h2h") > -1 || stageKey.indexOf("round-32") > -1 || stageKey.indexOf("round of 32") > -1 || stageKey.indexOf("round-16") > -1 || stageKey.indexOf("round of 16") > -1;
  }

  isFifaJourneyStage() {
    const stageKey = this.getFifaStageKey();
    return stageKey.indexOf("journey") > -1 || stageKey.indexOf("final") > -1;
  }

  getOwnLeaderboardData = (data = {}) => {
    return data.own_leaderboard ||
      data.ownLeaderboard ||
      data.own_data ||
      data.my_leaderboard ||
      data.user_leaderboard ||
      data.user_data ||
      data.current_user ||
      data.current_user_data ||
      data.my_data ||
      "";
  };

  getOwnLeaderboardFromList = (list = []) => {
    return (list || []).find(item => {
      return item.user_type == 1 || item.is_current_user == 1 || item.is_own == 1 || item.is_self == 1;
    }) || "";
  };

  getMappedOwnLeaderboardData = (data = {}) => {
    return this.getOwnLeaderboardData(data) || this.getOwnLeaderboardFromList(data.list || []);
  };

  isOwnLeaderboardItem = (item = {}, ownLeaderboard = this.state.ownLeaderboard) => {
    const profile = WSManager.getProfile() || {};

    if (!item) {
      return false;
    }

    if (item.user_type == 1 || item.is_current_user == 1 || item.is_own == 1 || item.is_self == 1) {
      return true;
    }

    if (!ownLeaderboard) {
      return false;
    }

    return (
      (item.user_id && ownLeaderboard.user_id && item.user_id == ownLeaderboard.user_id) ||
      (item.user_name && ownLeaderboard.user_name && item.user_name == ownLeaderboard.user_name) ||
      (item.user_id && profile.user_id && item.user_id == profile.user_id) ||
      (item.user_name && profile.user_name && item.user_name == profile.user_name)
    );
  };

  callQualificationApi() {
    const {
      selectedRound,
      selectedMonth,
      offset,
      ownLeaderboard,
      leaderboardResult,
      Searchkey,
      selectedFormat,
      selectedRPLCupTab,
      selectedGrpIDX
    } = this.state;

    let round_id = ''
    if (selectedRound != "") {
      round_id = selectedRound.value;
    }
    else if (selectedRPLCupTab == 0) {
      round_id = ''
    }
    else if (selectedMonth != "") {
      round_id = ''
    }
    else {
      // round_id = Constants.current_roundData.round_id
      round_id = ""
    }

    let param = {
      month: selectedMonth != "" ? selectedMonth.value : "",
      round_id: round_id,
      user_name: Searchkey,
      limit: 100,
      offset: offset
    };

    let url = ''
    if (selectedRPLCupTab == 0) {
      url = NC.GET_RPL_CUP_QUALIFICATION_DATA
      param['format'] = selectedFormat.value || 1;
    }
    if (selectedRPLCupTab == 1) {
      url = NC.GET_RPL_CUP_ELIMINATION_DATA
      param['group_name'] = Constants.RPLGroupArray.length > selectedGrpIDX ? Constants.RPLGroupArray[selectedGrpIDX].value : ''
    }

    this.setState({
      isLoading: true
    });

    WSManager.Rest(NC.baseURL + url, param).then(
      responseJson => {
        if (responseJson.response_code === NC.successCode) {
          this.setState(
            {
              leaderboardResult: offset == 0 ? responseJson.data.list || [] : [...leaderboardResult, ...responseJson.data.list],
              ownLeaderboard: offset == 0 ? this.getOwnLeaderboardData(responseJson.data) : ownLeaderboard,
              hasMore: responseJson.data.is_load_more,
              offset: responseJson.data.offset
            },
            () => {
              this.setState({ isLoading: false });
            }
          );
        } else {
          this.setState({ isLoading: false });
        }
      }
    );
  }

  callLeaderBoardApi() {
    Constants.SetValues.leaderboardOpenIDX(null);
    if (this.isRPLCupSelected()) {
      this.callQualificationApi()
    } else {
      const {
        selectedRound,
        selectedLeague,
        selectedContest,
        selectedMonth,
        offset,
        ownLeaderboard,
        leaderboardResult,
        Searchkey,
        selectedMainTab,
        selectedUserTab,
        selectedCategory,
        selectedFollowOption,
        selectedContestType,
        selectedContestDuration,
        selectedFifaStage
      } = this.state;
      const isFifaWorldCup = this.isFifaWorldCupSelected();
      const fifaStageValue = this.getFifaStageValue();
      const fifaStageData = this.getFifaStageData();

      let param = {
        // contest_type_id: selectedLeague != "" ? selectedLeague.value : selectedMainTab == 1 ? "5" : "", 
        contest_type_id: selectedLeague != "" ? (fifaStageData.contest_type_id || selectedLeague.value) : "",
        month: selectedMonth != "" ? selectedMonth.value : "",
        // round_id: selectedRound != "" ? selectedRound.value : selectedLeague == "" ? Constants.current_roundData.round_id : "",
        round_id: isFifaWorldCup ? (fifaStageData.round_id || fifaStageValue) : selectedRound != "" ? selectedRound.value : "",
        contest_id: selectedContest != "" ? selectedContest.value : "",
        user_name: Searchkey,
        limit: 100,
        offset: offset,
        user_type: selectedUserTab == 1 ? 1 : 0,
        tab_id: selectedMainTab
      };

      // if (selectedContestType.value == "2" && selectedMainTab == 1) {
      //   param.contest_id = selectedLeague != "" ? selectedLeague.value : "";
      //   param.contest_type_id = 4;
      // }

      if (selectedMainTab == 1) {
        param['is_season_long'] = selectedContestDuration.value;
      }

      if (selectedMainTab == 2) {
        param['follow_type'] = selectedFollowOption.value;
      }
      if (selectedCategory.id == 4) {
        param['region_id'] = selectedCategory.value;
      }

      if (isFifaWorldCup && selectedFifaStage != "") {
        param['stage_id'] = fifaStageData.stage_id || fifaStageValue;
        if (this.isFifaGroupStage()) {
          param['group_name'] = this.getSelectedFifaGroupOption().value;
        }
      }
console.log('selectedCategory', selectedCategory);

      if (selectedCategory != "" && selectedCategory.hasOwnProperty('id')) {
        param['type'] = selectedCategory.id;
        if (selectedCategory.id == '2') {
          param['country_id'] = selectedCategory.value;
        }
        if (selectedCategory.id == '3') {
          param['team_id'] = selectedCategory.value;
        }
      }
      const leaderboardUrl =
        isFifaWorldCup && this.isFifaJourneyStage()
          ? NC.GET_JOURNEY_TO_FINAL_LEADERBOARD
          : NC.GET_LEADERBOARD_RESULTS;
      this.setState({isLoading: true});
      WSManager.Rest(NC.baseURL + leaderboardUrl, param).then(
        responseJson => {
          if (responseJson.response_code === NC.successCode) {
            const isJourneyLeaderboard = leaderboardUrl === NC.GET_JOURNEY_TO_FINAL_LEADERBOARD;
            const nextLeaderboardResult = isJourneyLeaderboard
              ? responseJson.data || {}
              : offset == 0 ? responseJson.data.list || [] : [...leaderboardResult, ...(responseJson.data.list || [])];
            this.setState(
              {
                leaderboardResult: nextLeaderboardResult,
                ownLeaderboard: offset == 0 ? this.getOwnLeaderboardData(responseJson.data) : ownLeaderboard,
                hasMore: responseJson.data.is_load_more,
                offset: responseJson.data.offset,
                current_rank: responseJson.data.current_rank
              },
              () => {
                this.setState({ isLoading: false });
              }
            );
          } else {
            this.setState({ isLoading: false });
          }
        }
      );
    }
  }

  handleFollowerChange = selectedOption => {
    this.setState({
      selectedFollow: selectedOption.value,
      selectedFollowOption: selectedOption
    });
  };

  fetchMoreData = () => {
    console.log('====================================');
    console.log(this.state.offset);
    console.log('====================================');
    if (!this.state.isLoading && this.state.selectedRPLCupTab != 2) {
      this.callLeaderBoardApi();
    }
  };

  followAction = (uid, position, isFollow, event) => {
    event.stopPropagation();
    event.preventDefault();
    let param = {
      follower_id: uid
    };
    this.setState({
      isLoading: true
    });
    WSManager.Rest(NC.baseURL + (isFollow == 0 ? NC.USER_FOLLOW : NC.USER_UNFOLLOW), param).then(responseJson => {
      this.setState({
        isLoading: false
      });
      if (responseJson.response_code === NC.successCode) {
        let items = this.state.leaderboardResult;
        items[position].is_following = isFollow == 0 ? 1 : 0;
        this.setState({
          leaderboardResult: items
        });
        notify.show(responseJson.message, "success", 3000);
      }
    });
  };

  onTabUserClick = selectedTab1 => {
    Constants.SetValues.leaderboardOpenIDX(null);
    this.setState(
      {
        selectedUserTab: selectedTab1,
        offset: 0,
        hasMore: false
      },
      () => {
        this.callLeaderBoardApi();
      }
    );
  };

  onTabClick = selectedTab => {

    Constants.SetValues.leaderboardOpenIDX(null);
    this.setState(
      {
        selectedMainTab: selectedTab,
        selectedUserTab: 0,
        offset: 0,
        hasMore: false,
        selectedContest: "",
        selectedLeague: "",
        selectedRound: "",
        selectedMonth: "",
        Searchkey: "",
        selectedCategory: Constants.categories[0],
        selectedFollowOption: Constants.FollowOption[0],
        selectedContestType: "",
        searchClick: false,
        selectedContestDuration:Constants.contest_duration[0],
        selectedFifaStage: "",
        selectedFifaGroupIDX: 0
      },
      () => {
        this.initializeLeaderBoard();
        // if (selectedTab == 0 || selectedTab == 1 ) {
        //   this.callLeaderBoardApi();
        // }
      }
    );
  };

  renderLeaderboardData = () => {
    const {
      ownLeaderboard,
      leaderboardResult,
      selectedRound,
      selectedMonth,
      selectedRPLCupTab,
      isLoading,
      hasMore,
      selectedCategory,
      selectedContestType,
      selectedContest,
      selectedLeague,
      selectedFollowOption,
      selectedMainTab
    } = this.state;
    let isElimination = this.isRPLCupSelected() && selectedRPLCupTab == 1;
    const settings = {
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      className: "elimination-group",
      beforeChange: (current, next) => this.setState({ selectedGrpIDX: next }),
      afterChange: () => this.setState({ offset: 0, hasMore: false }, () => {
        this.callQualificationApi();
      })
    };

    return (
      <div className="leaderboard-data-wrap">
        {
          isElimination && <Slider ref={slider => (this.slider = slider)} {...settings}>
            {Constants.RPLGroupArray.map((item, idx) => {
              return (
                <div key={idx} className="p-2">
                  {item.label}
                </div>
              );
            })}
          </Slider>
        }
        <PanelGroup
          accordion
          id="accordion-controlled-example"
          onSelect={value => {
            Constants.SetValues.leaderboardOpenIDX(value);
          }}
        // defaultActiveKey={Constants.leaderboardOpenIDX}
        >
          {ownLeaderboard && (ownLeaderboard.user_id || ownLeaderboard.user_name || ownLeaderboard.display_name) && (
            <LeaderBoardRecord
              key={-1}
              selectedCategory={selectedCategory}
              selectedLeague={selectedLeague}
              selectedRound={selectedRound}
              selectedMonth={selectedMonth}
              selectedContestType={selectedContestType}
              selectedContest={selectedContest}
              selectedFollowOption={selectedFollowOption}
              selectedMainTab={selectedMainTab}
              isElimination={isElimination}
              idx={-1}
              item={ownLeaderboard}
              isOwn={true}
              {...this.props}
            />
          )}

          <div className="leaderboard-table-view leaderboard-table-head">
            <div className="rank-section">Rank</div>
            <div className="ref-section ml-3">ReF</div>
            <div className="pl-section">PL</div>
            <div className={`rp-section ${this.state.current_rank == "RP" ? 'active' : ''}`}>RP</div>
            {(selectedMonth != "" && !selectedRound.value) && (
              <div className={`sp-section ${this.state.current_rank == "MP" ? 'active' : ''}`}>MP</div>
            )}
            {(selectedMonth == "" || selectedRound.value) && !isElimination && (
              <div className={`sp-section ${this.state.current_rank == "SP" ? 'active' : ''}`}>SP</div>
            )}
            {(selectedMonth == "" || selectedRound.value) && isElimination && (
              <div className={`sp-section ${this.state.current_rank == "CP" ? 'active' : ''}`}>CP</div>
            )}
            <div className="follow-section">Follow</div>
          </div>

          <InfiniteScroll
            pullDownToRefresh={false}
            dataLength={leaderboardResult.length}
            next={this.fetchMoreData}
            hasMore={hasMore}
          >
            {leaderboardResult.length > 0 &&
              leaderboardResult.map((item, idx) => {
                return (
                  <LeaderBoardRecord
                    key={idx}
                    selectedCategory={selectedCategory}
                    selectedLeague={selectedLeague}
                    selectedContest={selectedContest}
                    selectedMonth={selectedMonth}
                    selectedRound={selectedRound}
                    selectedContestType={selectedContestType}
                    selectedFollowOption={selectedFollowOption}
                    selectedMainTab={selectedMainTab}
                    isElimination={isElimination}
                    idx={idx}
                    item={item}
                    isOwn={this.isOwnLeaderboardItem(item, ownLeaderboard)}
                    followAction={this.followAction}
                    {...this.props}
                  />
                );
              })}
            {leaderboardResult.length == 0 && !isLoading && (
              <NoDataScreen
                Content={{
                  ImgShown: Images.no_data_bg_image,
                  IsButton: true,
                  ButtonText: "Go to Lobby",
                  Title: "Oops! You may have joined this",
                  NoDataContent: "contest already, or it's closed.",
                  BtnAction: () => {
                    this.props.history.push({
                      pathname: "/dashboard/0"
                    });
                  },
                  WithFilter: ""
                }}
              />
            )}
          </InfiniteScroll>
        </PanelGroup>
      </div>
    );
  };

  getFifaStageUsers = (options = {}) => {
    const { Searchkey, leaderboardResult } = this.state;
    const resultRows = Array.isArray(leaderboardResult) ? leaderboardResult : [];
    const rows = options.flattenGroups ? this.flattenFifaGroupRows(resultRows) : resultRows;
    let users = rows.map(this.normalizeFifaUser);

    if (Searchkey.trim().length > 0) {
      users = users.filter(item => {
        const searchText = `${item.display_name} ${item.user_name}`.toLowerCase();
        return searchText.indexOf(Searchkey.toLowerCase()) > -1;
      });
    }

    return users;
  };

  getFifaOwnUser = (users, selectedGroup = "") => {
    const { ownLeaderboard } = this.state;

    if (
      ownLeaderboard &&
      typeof ownLeaderboard === "object" &&
      Object.keys(ownLeaderboard).length > 0
    ) {
      const ownUser = this.normalizeFifaUser(ownLeaderboard);
      if (!selectedGroup || this.getFifaGroupName(ownUser) === selectedGroup.value) {
        return ownUser;
      }
    }

    return (users || []).find(item => item.user_type == 1 || item.is_current_user == 1 || item.is_own == 1);
  };

  flattenFifaGroupRows = (rows = []) => {
    const flatRows = [];

    (rows || []).forEach(item => {
      const childRows =
        item.users ||
        item.user_list ||
        item.leaderboard ||
        item.leaderboard_list ||
        item.participants ||
        item.participant_list ||
        item.members ||
        "";
      const groupName = this.getFifaGroupName(item);

      if (Array.isArray(childRows)) {
        childRows.forEach(child => {
          flatRows.push({
            ...child,
            group_name: this.getFifaGroupName(child) || groupName
          });
        });
        return;
      }

      flatRows.push(item);
    });

    return flatRows;
  };

  getFlagEmoji = (countryAbbr) => {
    if (!countryAbbr || countryAbbr.length !== 2) return '';
    return countryAbbr.toUpperCase().replace(/./g, char =>
      String.fromCodePoint(127397 + char.charCodeAt(0))
    );
  };

  normalizeFifaUser = (item = {}) => {
    const status = item.status || item.qualification_status || item.user_status || (
      item.is_eliminated == 1 ? "eliminated" : item.is_qualified == 1 ? "qualified" : "pending"
    );

    return {
      ...item,
      rank: item.rank || item.position || item.user_rank || "--",
      display_name: item.display_name || item.name || item.full_name || item.user_name || "-",
      user_name: item.user_name || item.username || item.display_name || "-",
      total_plays: item.total_plays || item.plays || item.played || "--",
      round_points: item.round_points || item.rp || item.points || "--",
      season_point: item.season_point || item.season_points || item.sp || item.total_points || "--",
      image: item.image || item.user_image || item.profile_image,
      group_name: this.getFifaGroupName(item) || item.group_name,
      country_abbr: item.country_abbr || item.abbr || '',
      country_name: item.country_name || '',
      status: status
    };
  };

  getFifaH2HPairings = () => {
    const rows = this.getFifaStageUsers();
    const apiPairings = [];
    const loosePlayers = [];

    rows.forEach((item, idx) => {
      if (item.players && item.players.length > 0) {
        apiPairings.push({
          title: this.getFifaH2HTitle(item, apiPairings.length),
          players: this.getFifaH2HPlayers(item)
        });
        return;
      }

      loosePlayers.push({
        ...item,
        pairingKey: this.getFifaH2HPairingKey(item, idx)
      });
    });

    const groupedPairings = _.map(_.groupBy(loosePlayers, "pairingKey"), (players, key) => ({
      title: this.getFifaH2HTitle(players[0], key),
      players: players.slice(0, 2)
    }));

    return [...apiPairings, ...groupedPairings].filter(pair => pair.players.length > 0);
  };

  getFifaH2HPairingKey = (item = {}, idx = 0) => {
    return item.group_num || item.group_number || item.group_id || item.group_name || item.matchup_id || item.match_id || Math.floor(idx / 2);
  };

  getFifaH2HTitle = (item = {}, fallback = 0) => {
    const groupNumber = item.group_num || item.group_number || item.group_id || "";
    if (item.matchup_name || item.title) {
      return item.matchup_name || item.title;
    }
    if (groupNumber) {
      return `Matchup ${groupNumber}`;
    }
    if (item.group_name) {
      return item.group_name;
    }
    const fallbackNumber = parseInt(fallback, 10);
    return `Matchup ${!Number.isNaN(fallbackNumber) ? fallbackNumber + 1 : fallback}`;
  };

  getFifaH2HPlayers = (item = {}) => {
    const players = this.parseFifaJourneyPlayers(item.players);
    return players.map(player => this.normalizeFifaUser({
      ...player,
      group_num: item.group_num || player.group_num,
      group_name: item.group_name || player.group_name,
      matchup_id: item.matchup_id || player.matchup_id,
      winner_user_id: item.winner_user_id || player.winner_user_id
    }));
  };

  renderFifaNoData = () => {
    const { isLoading } = this.state;
    if (isLoading) {
      return null;
    }
    return (
      <NoDataScreen
        Content={{
          ImgShown: Images.no_data_bg_image,
          IsButton: false,
          Title: "No leaderboard data available",
          NoDataContent: "Please try another stage or filter.",
          WithFilter: ""
        }}
      />
    );
  };

  renderFifaRow = (item, idx, isOwn = false) => {
    const {
      selectedCategory,
      selectedLeague,
      selectedRound,
      selectedMonth,
      selectedContestType,
      selectedContest,
      selectedFollowOption,
      selectedMainTab
    } = this.state;

    return (
      <LeaderBoardRecord
        key={`${item.user_id || item.user_name}-${idx}`}
        selectedCategory={selectedCategory}
        selectedLeague={selectedLeague}
        selectedRound={selectedRound}
        selectedMonth={selectedMonth}
        selectedContestType={selectedContestType}
        selectedContest={selectedContest}
        selectedFollowOption={selectedFollowOption}
        selectedMainTab={selectedMainTab}
        idx={idx}
        item={item}
        isOwn={isOwn}
        isFifaRow={true}
        followAction={this.followAction}
        {...this.props}
      />
    );
  };

  renderFifaRankingStage = () => {
    const { hasMore } = this.state;
    const allUsers = this.getFifaStageUsers({ flattenGroups: true });
    const isGroupStage = this.isFifaGroupStage();
    const groupOptions = this.getFifaGroupFilterOptions();
    const selectedGroup = this.getSelectedFifaGroupOption();
    const usersHaveGroup = allUsers.some(item => this.getFifaGroupName(item));
    const users = isGroupStage && usersHaveGroup
      ? allUsers.filter(item => this.getFifaGroupName(item) === selectedGroup.label)
      : allUsers;
    const ownUser = this.getFifaOwnUser(users, isGroupStage ? { ...selectedGroup, value: selectedGroup.label } : "");
    const fifaGroupSliderSettings = {
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      initialSlide: this.state.selectedFifaGroupIDX,
      afterChange: this.handleFifaGroupSlideChange
    };

    return (
      <div className={`leaderboard-data-wrap fifa-stage-wrap ${isGroupStage ? "fifa-group-stage-wrap" : ""}`}>
        {isGroupStage && (
          <div className="fifa-group-filter-bar">
            <button type="button" onClick={() => this.handleFifaGroupChange(-1)}>
              <i className="icon-arrow-left" />
            </button>
            <Slider
              key={`fifa-group-${this.getFifaStageValue()}-${this.state.selectedFifaGroupIDX}`}
              ref={slider => (this.fifaGroupSlider = slider)}
              {...fifaGroupSliderSettings}
            >
              {groupOptions.map(item => (
                <strong key={item.value}>{item.label}</strong>
              ))}
            </Slider>
            <button type="button" onClick={() => this.handleFifaGroupChange(1)}>
              <i className="icon-arrow-right" />
            </button>
            <button
              type="button"
              onClick={() => this.setState({ searchClick: !this.state.searchClick })}
            >
              <i className="icon-search" />
            </button>
          </div>
        )}
        <PanelGroup accordion id="fifa-world-cup-ranking">
          {ownUser && this.renderFifaRow(ownUser, -1, true)}
          <div className="leaderboard-table-view leaderboard-table-head">
            <div className="rank-section">Rank</div>
            <div className="ref-section ml-3">ReF</div>
            <div className="pl-section">PL</div>
            <div className="rp-section">RP</div>
            <div className="sp-section">SP</div>
            <div className="follow-section">Follow</div>
          </div>
          <InfiniteScroll
            pullDownToRefresh={false}
            dataLength={users.length}
            next={this.fetchMoreData}
            hasMore={hasMore}
          >
            {users.map((item, idx) => this.renderFifaRow(item, idx))}
            {users.length == 0 && this.renderFifaNoData()}
          </InfiniteScroll>
        </PanelGroup>
      </div>
    );
  };

  renderFifaH2HStage = () => {
    const pairings = this.getFifaH2HPairings();

    return (
      <div className="fifa-h2h-wrap">
        {/* <div className="fifa-stage-summary">
          <strong>{selectedFifaStage.label || "H2H"}</strong>
          <span>{selectedStageKey.indexOf("16") > -1 ? "8" : "16"} H2H matchup groups</span>
        </div> */}
        <div className="fifa-h2h-grid">
          {pairings.map((pair, idx) => (
            <div className="fifa-h2h-card" key={idx}>
              <div className="fifa-h2h-title">{pair.title}</div>
              <div className="fifa-h2h-single-row">
                {this.renderFifaH2HPlayer(pair.players[0])}
                <div className="fifa-vs">vs</div>
                {pair.players[1] ? this.renderFifaH2HPlayer(pair.players[1]) : <div className="fifa-h2h-player empty-slot">TBD</div>}
              </div>
            </div>
          ))}
          {pairings.length == 0 && this.renderFifaNoData()}
        </div>
      </div>
    );
  };

  renderFifaJourneyStage = () => {
    const bracketPlayers = this.getFifaJourneyBracketPlayers();
    const hasJourneyData = this.hasFifaJourneyData();
    if (!hasJourneyData) {
      return (
        <div className="fifa-journey-wrap">
          {/* <div className="fifa-stage-summary">
            <strong>Journey to Final</strong>
            <span>Final path</span>
          </div> */}
          {this.renderFifaNoData()}
        </div>
      );
    }

    return (
      <div className="fifa-journey-wrap">
        {/* <div className="fifa-stage-summary">
          <strong>Journey to Final</strong>
          <span>Final path</span>
        </div> */}
        <LeaderboardBracket
          players={bracketPlayers}
          className="fifa-final-bracket"
          onPlayerClick={this.handleFifaBracketPlayerClick}
        />
      </div>
    );
  };

  handleFifaBracketPlayerClick = player => {
    const item = player && player.raw ? player.raw : {};
    if (item.user_id) {
      this.props.history.push(`/profile/${item.user_id}`);
    }
  };

  hasFifaJourneyData = () => {
    const { leaderboardResult } = this.state;
    if (leaderboardResult && Array.isArray(leaderboardResult.round_data)) {
      return leaderboardResult.round_data.length > 0;
    }
    return Array.isArray(leaderboardResult) && leaderboardResult.length > 0;
  };

  getFifaJourneyRoundKey = round => {
    const roundName = `${round.round_name || round.name || round.stage_name || ""}`.toLowerCase();
    if (roundName.indexOf("final") > -1 && roundName.indexOf("semi") === -1 && roundName.indexOf("quarter") === -1) {
      return "final";
    }
    if (roundName.indexOf("semi") > -1) {
      return "semi";
    }
    if (roundName.indexOf("quarter") > -1) {
      return "quarter";
    }
    return "";
  };

  parseFifaJourneyPlayers = players => {
    if (Array.isArray(players)) {
      return players;
    }
    if (typeof players === "string" && players.trim()) {
      try {
        const parsedPlayers = JSON.parse(players);
        return Array.isArray(parsedPlayers) ? parsedPlayers : [];
      }
      catch (e) {
        return [];
      }
    }
    return [];
  };

  getFifaJourneyUser = (userId, userDetails = {}, matchupPlayer = {}) => {
    if (!userId) {
      return "";
    }
    const userDetail = userDetails[userId] || userDetails[String(userId)] || {};
    return this.normalizeFifaUser({
      ...userDetail,
      ...matchupPlayer,
      user_id: userDetail.user_id || matchupPlayer.user_id || userId
    });
  };

  getFifaJourneyMatchupPlayer = (matchup = {}, userId, userDetails = {}) => {
    const players = this.parseFifaJourneyPlayers(matchup.players);
    const matchupPlayer = players.find(player => player.user_id && player.user_id == userId) || {};
    return this.getFifaJourneyUser(userId, userDetails, matchupPlayer);
  };

  getFifaJourneyMatchupSlots = (roundKey, matchup, idx) => {
    const roundSlots = FIFA_JOURNEY_ROUND_SLOTS[roundKey] || [];
    if (!roundSlots.length) {
      return "";
    }
    const groupIndex = parseInt(matchup.group_num, 10) - 1;
    return roundSlots[!Number.isNaN(groupIndex) && groupIndex >= 0 ? groupIndex : idx] || "";
  };

  getFifaJourneyPlayerName = item => {
    if (!item) {
      return "--";
    }
    const playerName = item.display_name || item.user_name || item.name || item.full_name || "";
    return playerName && playerName !== "-" ? playerName : "--";
  };

  applyFifaJourneyMatchupToSlots = (playersBySlot, matchup = {}, slotGroup = "", userDetails = {}) => {
    if (!slotGroup) {
      return;
    }

    const matchupUserIds = [matchup.user1_id, matchup.user2_id];
    matchupUserIds.forEach((userId, idx) => {
      const slotId = slotGroup.playerSlots[idx];
      if (!slotId || playersBySlot[slotId]) {
        return;
      }
      const player = this.getFifaJourneyMatchupPlayer(matchup, userId, userDetails);
      if (player) {
        playersBySlot[slotId] = player;
      }
    });

    const winner = this.getFifaJourneyMatchupPlayer(matchup, matchup.winner_user_id, userDetails);
    if (winner) {
      playersBySlot[slotGroup.winnerSlot] = winner;
    }
  };

  getFifaJourneyBracketPlayers = () => {
    const { leaderboardResult } = this.state;
    const playersBySlot = {};

    if (leaderboardResult && Array.isArray(leaderboardResult.round_data)) {
      const userDetails = leaderboardResult.user_details || {};
      leaderboardResult.round_data.forEach(round => {
        const roundKey = this.getFifaJourneyRoundKey(round);
        const matchups = round.matchup || round.matchups || [];
        (matchups || []).forEach((matchup, idx) => {
          const slotGroup = this.getFifaJourneyMatchupSlots(roundKey, matchup, idx);
          this.applyFifaJourneyMatchupToSlots(playersBySlot, matchup, slotGroup, userDetails);
        });
      });
    }
    else {
      this.getFifaStageUsers({ flattenGroups: true }).forEach((item, idx) => {
        const slot = FIFA_JOURNEY_BRACKET_SLOTS[idx];
        if (slot) {
          playersBySlot[slot.id] = item;
        }
      });
    }

    return FIFA_JOURNEY_BRACKET_SLOTS.map(slot => {
      const item = playersBySlot[slot.id];
      return {
        ...slot,
        name: this.getFifaJourneyPlayerName(item),
        avatar: item ? item.image : "",
        status: item ? slot.status : "empty",
        raw: item
      };
    });
  };

  renderFifaH2HPlayer = player => {
    const flagEmoji = player && player.country_abbr ? this.getFlagEmoji(player.country_abbr) : '';
    return (
      <div className="fifa-h2h-player">
        {/* {this.renderFifaStatus(player.status)} */}
        {flagEmoji && <span className="fifa-h2h-flag" title={player.country_name}>{flagEmoji}</span>}
        <img src={(player && player.image) || Images.DEFAULT_USER} alt="" />
        <span>
          <div className="fifa-h2h-player-name">
            {player ? player.display_name : "TBD"}
          </div>
          <div className="us_name">@{player ? player.user_name : "-"}</div>
        </span>
        <div className="fifa-h2h-score">
          <strong>{player ? player.round_points : "--"}</strong>
          <small>RP</small>
        </div>
      </div>
    );
  };

  renderFifaBracketNode = (item, isChampion = false, className = "", key = "") => {
    if (!item) {
      return null;
    }
    return (
      <div className={`fifa-bracket-node ${isChampion ? "champion" : ""} ${className}`} key={key}>
        <img src={item.image || Images.DEFAULT_USER} alt="" />
        <span>{item.display_name}</span>
      </div>
    );
  };

  renderFifaWorldCup = () => {
    if (this.isFifaH2HStage()) {
      return this.renderFifaH2HStage();
    }
    if (this.isFifaJourneyStage()) {
      return this.renderFifaJourneyStage();
    }
    return this.renderFifaRankingStage();
  };

  renderRefLeague = () => {
    const {
      searchClick,
      selectedRound,
      selectedLeague,
      selectedContest,
      selectedMonth,
      selectedFormat,
      Searchkey,
      selectedCategory,
      selectedFollowOption,
      selectedMainTab,
      selectedFifaStage
    } = this.state;


    let filterOptions = ["league", "fifaStage", "round", "contest", "month"];
    if (selectedMainTab == 2) {
      filterOptions = ["league", "fifaStage", "round", "contest", "month", "network"];
    }
    return (
      <div className="leaderboard-wrapper">


        <div className="leaderboard-header">
          <div
            className="select-option-btn"
            onClick={() =>
              Header.FilterModalShow(
                {
                  filterOption: filterOptions,
                  selectedLeague: selectedLeague,
                  selectedRound: selectedRound,
                  selectedContest: selectedContest,
                  selectedMonth: selectedMonth,
                  selectedFormat: selectedFormat,
                  selectedCategory: selectedCategory,
                  selectedFollowOption: selectedFollowOption,
                  additionalLeagueOptions: LEADERBOARD_EXTRA_LEAGUE_OPTIONS,
                  fifaStageOptions: [],
                  selectedFifaStage: selectedFifaStage,
                  isFrom: selectedMainTab == 2 ? "PersonalLeaderboard" : "leaderboard",

                },
                this.filterAction.bind(this)
              )
            }
          >
            {selectedLeague != "" ||
              selectedRound != "" ||
              selectedContest != "" ||
              selectedMonth != "" ||
              selectedFifaStage.value != "global-ranking"
              ? "Filters Applied"
              : "Select"}
            <div className="arrow-section">
              <i className="icon-arrow-sort" />
            </div>
          </div>
        </div>

        <div className="heading-section ">
          <Row>
            <Col md={6} xs={12} className="p-v-sm hidden-xs purple">
              <React.Fragment>
                {/* <img
                  src={Images.LOGO}
                  width="20px"
                    alt=""
                  className="filter-with-logo"
                /> */}
                {this.isFifaWorldCupSelected() ? `${FIFA_LEAGUE_OPTION.label}` : selectedLeague.label || "Global Series"}
              </React.Fragment>
            </Col>
            <Col md={6} xs={12}>
              <div
                className={
                  "search-btn" +
                  (searchClick ? " search-full" : "")
                }
              >
                <FormControl
                  type="text"
                  placeholder="Search"
                  value={Searchkey}
                  onChange={e => {
                    this.setState({
                      Searchkey: e.target.value,
                      offset: 0,
                      hasMore: false
                    });
                    this.SearchUserReq();
                  }}
                />
                <div
                  className="search-box"
                  onClick={() =>
                    this.setState(
                      {
                        searchClick: !searchClick
                      },
                      () => {
                        if (
                          searchClick &&
                          Searchkey.length > 0
                        ) {
                          this.setState(
                            {
                              Searchkey: "",
                              offset: 0,
                              hasMore: false
                            },
                            () => {
                              setTimeout(() => {
                                this.callLeaderBoardApi();
                              }, 500);
                            }
                          );
                        }
                      }
                    )
                  }
                >
                  <i
                    className={
                      searchClick
                        ? "icon-close"
                        : "icon-search"
                    }
                  />
                </div>
              </div>
              <span className={"filter-by-name purple"}>
                <React.Fragment>
                  {/* <img
                    src={Images.LOGO}
                    width="20px"
                    alt=""
                    className="filter-with-logo"
                  /> */}
                  {this.isFifaWorldCupSelected() ? FIFA_LEAGUE_OPTION.label : selectedLeague.label || "Global Series"}
                </React.Fragment>
              </span>
            </Col>
          </Row>
          <div className={'er-links'}>
            {/* <a
              href
              onClick={() => this.showScoringRules()}
              className="earn-points-link"
            >How To Earn Points</a> */}
            <a
              // href
              onClick={() => this.showScoringRules()}
              className="earn-points-link"
            >Rules</a>

            <a
              href="#prizes"
              onClick={(e) => this.showPrizes(e)}
              className="earn-points-link"
            >Prize</a>

            <a
              // href
              onClick={() => this.showStats()}
              className="earn-points-link"
            >STATs</a>

          </div>
        </div>
        {this.isFifaWorldCupSelected() ? this.renderFifaWorldCup() : this.renderLeaderboardData()}
      </div>
    );
  }

  isRPLCupSelected() {
    return this.state.selectedLeague.value != '' && this.state.selectedLeague.value == 0
  }

  handleRPLCupTab = (tab) => {
    Constants.SetValues.leaderboardOpenIDX(null);
    this.setState(
      {
        selectedRPLCupTab: tab,
        offset: 0,
        hasMore: false,
        selectedMonth: this.state.selectedRPLCupTab == tab ? this.state.selectedMonth : '',
        selectedRound: this.state.selectedRPLCupTab == tab ? this.state.selectedRound : '',
        Searchkey: "",
        searchClick: false
      },
      () => {
        if (tab == 0 || tab == 1) {
          this.callQualificationApi();
        }
      }
    );
  }

  renderRPLCup = () => {

    const {
      searchClick,
      selectedRound,
      selectedLeague,
      selectedContest,
      selectedMonth,
      selectedFormat,
      Searchkey,
      leaderboardResult,
      isLoading,
      hasMore,
      selectedRPLCupTab,
      selectedMainTab,
      selectedFollowOption,
      selectedContestType,
      selectedCategory
    } = this.state;
    let isElimination = this.isRPLCupSelected() && selectedRPLCupTab == 1

    let filterOptions = ["league", "round", "contest", "month", "category"];
    if (selectedMainTab == 2) {
      filterOptions = ["league", "round", "contest", "month", "category", "network"];
    }

    return (
      <div className="leaderboard-wrapper">
        <div className="leaderboard-header">
          <div
            className="select-option-btn"
            onClick={() =>
              Header.FilterModalShow(
                {
                  filterOption: filterOptions,
                  selectedLeague: selectedLeague,
                  selectedRound: selectedRound,
                  selectedContest: selectedContest,
                  selectedMonth: selectedMonth,
                  selectedFormat: selectedFormat,
                  selectedFollowOption: selectedFollowOption,
                  isFrom: selectedMainTab == 2 ? "PersonalLeaderboard" : "leaderboard",
                  isElimination: isElimination
                },
                this.filterAction.bind(this)
              )
            }
          >
            {selectedLeague != "" ||
              selectedRound != "" ||
              selectedContest != "" ||
              selectedMonth != ""
              ? "Filters Applied"
              : "Select"}
            <div className="arrow-section">
              <i className="icon-arrow-sort" />
            </div>
          </div>
        </div>

        <div className="heading-section ">
          <Row>
            <Col md={6} xs={12} className="p-v-sm hidden-xs purple">
              <React.Fragment>
                {/* <img
                  src={Images.LOGO}
                  width="20px"
                  alt=""
                  className="filter-with-logo"
                /> */}
                {selectedLeague.label ||
                  "RPL Cup"}<span style={{ fontSize: 13, fontFamily: 'Muli-BoldItalic' }}> - {selectedFormat.label ||
                    "Stage"}</span>
              </React.Fragment>
            </Col>
            <Col md={6} xs={12}>
              <div
                className={
                  "search-btn" +
                  (searchClick ? " search-full" : "")
                }
              >
                <FormControl
                  type="text"
                  placeholder="Search"
                  value={Searchkey}
                  onChange={e => {
                    this.setState({
                      Searchkey: e.target.value,
                      offset: 0,
                      hasMore: false
                    });
                    this.SearchUserReq();
                  }}
                />
                <div
                  className="search-box"
                  onClick={() =>
                    this.setState(
                      {
                        searchClick: !searchClick
                      },
                      () => {
                        if (
                          searchClick &&
                          Searchkey.length > 0
                        ) {
                          this.setState(
                            {
                              Searchkey: "",
                              offset: 0,
                              hasMore: false
                            },
                            () => {
                              setTimeout(() => {
                                this.callLeaderBoardApi();
                              }, 500);
                            }
                          );
                        }
                      }
                    )
                  }
                >
                  <i
                    className={
                      searchClick
                        ? "icon-close"
                        : "icon-search"
                    }
                  />
                </div>
              </div>
              <span className={"filter-by-name purple"}>
                <React.Fragment>
                  {/* <img
                    src={Images.LOGO}
                    width="20px"
                    alt=""
                    className="filter-with-logo"
                  /> */}
                  {selectedLeague.label || "RPL Cup"}<span style={{ fontSize: 13, fontFamily: 'Muli-BoldItalic' }}> - {selectedFormat.label ||
                    "Stage"}</span>
                </React.Fragment>
              </span>
            </Col>
          </Row>
          <div className={'er-links'}>
            {/* <a
              href
              onClick={() => this.showScoringRules()}
              className="earn-points-link"
            >
              How To Earn Points
                              </a> */}

            <a
              href
              onClick={() => this.showScoringRules()}
              className="earn-points-link"
            >Rules</a>

            <a
              href="#prizes"
              onClick={(e) => this.showPrizes(e)}
              className="earn-points-link"
            >Prize</a>

            <a
              href
              onClick={() => this.showStats()}
              className="earn-points-link"
            >STATs</a>
          </div>
        </div>

        <Tab.Container
          id="tabs-with-dropdown1"
          defaultActiveKey="qualification"
          className="default-tab"
        >
          <Row className="clearfix">
            <Col sm={12}>
              <Nav bsStyle="tabs shadow m-b-sm">
                <NavItem onClick={() => this.handleRPLCupTab(0)} eventKey="qualification">
                  Qualification
                                  </NavItem>
                <NavItem
                  onClick={() => this.handleRPLCupTab(1)}
                  eventKey="seeding-elimination"
                  className="bg-label"
                >
                  Seeding/
                                    <br />
                  Elimination
                                  </NavItem>
                <NavItem onClick={() => this.handleRPLCupTab(2)} eventKey="final">Final</NavItem>
              </Nav>
            </Col>
            <Col sm={12}>
              <Tab.Content animation>
                <Tab.Pane eventKey="qualification">
                  <div className="leaderboard-data-wrap">
                    <PanelGroup
                      accordion
                      id="accordion-controlled-example"
                    >
                      <div className="leaderboard-table-view leaderboard-table-head">
                        <div className="rank-section serial">#</div>
                        <div className="ref-section username">ReFPredictor</div>
                        <div className="pl-section batch">Batch</div>
                        <div className="follow-section">Follow</div>
                      </div>
                      <InfiniteScroll
                        pullDownToRefresh={false}
                        dataLength={leaderboardResult.length}
                        next={this.fetchMoreData}
                        hasMore={hasMore}
                      >
                        {leaderboardResult.length > 0 &&
                          leaderboardResult.map((item, idx) => {
                            return (
                              <LeaderBoardRecord
                                key={idx}
                                selectedCategory={selectedCategory}
                                selectedLeague={selectedLeague}
                                selectedRound={selectedRound}
                                selectedMonth={selectedMonth}
                                selectedContestType={selectedContestType}
                                selectedContest={selectedContest}
                                selectedFollowOption={selectedFollowOption}
                                selectedMainTab={selectedMainTab}
                                idx={idx}
                                item={item}
                                followAction={this.followAction}
                                isQualification={true}
                                {...this.props}
                              />
                            );
                          })}
                        {leaderboardResult.length == 0 && !isLoading && (
                          <NoDataScreen
                            Content={{
                              ImgShown: Images.no_data_bg_image,
                              IsButton: true,
                              ButtonText: "Go to Lobby",
                              Title: "Oops! You may have joined this",
                              NoDataContent: "contest already, or it's closed.",
                              BtnAction: () => {
                                this.props.history.push({
                                  pathname: "/dashboard/0"
                                });
                              },
                              WithFilter: ""
                            }}
                          />
                        )}
                      </InfiniteScroll>
                    </PanelGroup>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="seeding-elimination">
                  {this.renderLeaderboardData()}
                </Tab.Pane>
                <Tab.Pane eventKey="final">
                  <RPLFinalTab tab={selectedRPLCupTab} />
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </div>
    );
  }


  selectCategory = (obj) => {
    this.setState({
      selectedCategory:obj,
      selectedRound: "",
      selectedLeague: "",
      selectedContest: "",
      selectedMonth: "",
      selectedFormat: "",
      selectedFollow: "",
      selectedContestType: "",
      leaderboardResult:[],
      ownLeaderboard:[],
      offset: 0,
      hasMore: false,
    }, () => {
      this.callLeaderBoardApi()
    })
  }

  render() {
    const {
      searchClick,
      selectedRound,
      selectedLeague,
      selectedContest,
      selectedMonth,
      isLoading,
      selectedFollowOption,
      Searchkey,
      selectedUserTab,
      selectedMainTab,
      selectedCategory,
      selectedContestType,
      pageBanner,
      categories_list,
      selectedContestDuration
    } = this.state;
    const HeaderOption = {
      menu: true,
      Notification: true,
      Logo: true
    };
    return (
      <MyContext.Consumer>
        {context => (
          <div className="web-container leaderboard-web-container web-container-white">
            <Helmet titleTemplate={`${MetaData.template} | %s`}>
              <title>{MetaData.leaderboard.title}</title>
              <meta
                name="description"
                content={MetaData.leaderboard.description}
              />
              <meta name="keywords" content={MetaData.leaderboard.keywords} />
            </Helmet>
            {isLoading && <Loader />}
            <Header
              {...this.props}
              HeaderOption={HeaderOption}
            />

            
            <div>
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey={
                  selectedLeague.value == "1" || selectedLeague.value == "4"
                    ? "contest"
                    : "refpredictor"
                }
              >
                <Row>
                  <Col sm={12}>
                    <SubHeader
                      Title="Leaderboard"
                      ImgShown={Images.HEADER_BG}
                      BannerImage=""
                    // AddClassName="page-inner-header-xlg"
                    />
                    <Nav

                      className="tab-navigation tab-navigation-three tab-navigation-upper"
                    >
                      <NavItem
                        onClick={() => this.onTabClick(0)}
                        className={`${selectedMainTab == 0 ? 'active' : ''}`}
                      // eventKey="refpredictor"
                      >
                        Tournament
                      </NavItem>
                      <NavItem
                        onClick={() => this.onTabClick(1)}
                        className={`${selectedMainTab == 1 ? 'active' : ''}`}
                      // eventKey="contest"
                      >
                        Contests
                      </NavItem>
                      <NavItem
                        onClick={() => this.onTabClick(2)}
                        className={`${selectedMainTab == 2 ? 'active' : ''}`}
                      // eventKey="personal"
                      >
                        Personal
                      </NavItem>
                      {/* <NavItem
                        onClick={() => this.onTabClick(3)}
                        eventKey="refsocial"
                      >
                        ReFSocial <i className="icon-notification" />{" "}
                        <span className="red-dot" />
                      </NavItem> */}
                    </Nav>

                    {
                      (pageBanner && pageBanner.length > 0) &&
                      <div className={'lb-ban-wrap'}>
                        <Slider {...Constants.BANNER_SLIDER_SETTINGS}>
                          {pageBanner.map((itm, i) => {
                            return <div key={i} className={'lb-banner'}>
                              <picture>
                                {itm.mobile_image && <source media="(max-width: 550px)" srcSet={itm.mobile_image} />}
                                <img src={itm.image} />
                              </picture>
                            </div>
                          })}
                        </Slider>
                      </div>
                    }

                    {/* {
                      selectedTab != 2 && */}
                      <div className={'lb_type_tab15'}>
                        {categories_list.map((itm, i) => {
                          return <div
                            className={`ct-tab ${selectedCategory.id == itm.id ? 'active' : ''}`}
                            onClick={() => this.selectCategory(itm)}
                            key={i}>{itm.name}</div>
                        })}
                      </div>
                    {/* } */}


                    <Tab.Content>

                      <Tab.Pane eventKey={0} className={`${selectedMainTab == 0 ? 'active in' : ''}`}>
                        {this.isRPLCupSelected() ? this.renderRPLCup() : this.renderRefLeague()}
                      </Tab.Pane>

                      <Tab.Pane eventKey={1} className={`${selectedMainTab == 1 ? 'active in' : ''}`}>
                        {
                          <div className="leaderboard-wrapper">
                            <div className="leaderboard-header">
                              <div
                                className="select-option-btn"
                                onClick={() =>
                                  Header.FilterModalShow(
                                    {
                                      filterOption: [
                                        "league",
                                        "round",
                                        "contest",
                                        "month",
                                        // "category",
                                        "contestType",
                                        "contestDuration"
                                      ],
                                      selectedLeague: selectedLeague,
                                      selectedRound: selectedRound,
                                      selectedContest: selectedContest,
                                      selectedMonth: selectedMonth,
                                      selectedCategory: selectedCategory,
                                      selectedContestType: selectedContestType,
                                      selectedContestDuration:selectedContestDuration,
                                      isFrom: "contest"
                                    },
                                    this.filterAction.bind(this)
                                  )
                                }
                              >
                                {selectedLeague != "" ||
                                  selectedRound != "" ||
                                  selectedContest != "" ||
                                  selectedMonth != ""
                                  ? "Filters Applied"
                                  : "Select"}
                                <div className="arrow-section">
                                  <i className="icon-arrow-sort" />
                                </div>
                              </div>
                            </div>

                            <div className="heading-section ">
                              <Row>
                                <Col
                                  md={6}
                                  xs={12}
                                  className="p-v-sm hidden-xs"
                                >
                                  <React.Fragment>
                                    {selectedLeague.label || (selectedContestType == "" || selectedContestType.value == 1) ? "Global Series" : ""}
                                  </React.Fragment>
                                </Col>
                                <Col md={6} xs={12}>
                                  <div
                                    className={
                                      "search-btn" +
                                      (searchClick ? " search-full" : "")
                                    }
                                  >
                                    <FormControl
                                      type="text"
                                      placeholder="Search"
                                      value={Searchkey}
                                      onChange={e => {
                                        this.setState({
                                          Searchkey: e.target.value,
                                          offset: 0,
                                          hasMore: false
                                        });
                                        this.SearchUserReq();
                                      }}
                                    />
                                    <div
                                      className="search-box"
                                      onClick={() =>
                                        this.setState(
                                          {
                                            searchClick: !searchClick
                                          },
                                          () => {
                                            if (
                                              searchClick &&
                                              Searchkey.length > 0
                                            ) {
                                              this.setState(
                                                {
                                                  Searchkey: "",
                                                  offset: 0,
                                                  hasMore: false
                                                },
                                                () => {
                                                  setTimeout(() => {
                                                    this.callLeaderBoardApi();
                                                  }, 500);
                                                }
                                              );
                                            }
                                          }
                                        )
                                      }
                                    >
                                      <i
                                        className={
                                          searchClick
                                            ? "icon-close"
                                            : "icon-search"
                                        }
                                      />
                                    </div>
                                  </div>
                                  <span className={"filter-by-name"}>
                                    <React.Fragment>
                                      {selectedLeague.label || "Global Series"}
                                    </React.Fragment>
                                  </span>
                                </Col>
                              </Row>
                              <div className={'er-links'}>
                                {/* <a
                                  href
                                  onClick={() => this.showScoringRules()}
                                  className="earn-points-link"
                                >
                                  How To Earn Points
                                </a> */}

                                <a
                                  // href
                                  onClick={() => this.showScoringRules()}
                                  className="earn-points-link"
                                >Rules</a>

                                <a
                                  href="#prizes"
                                  onClick={(e) => this.showPrizes(e)}
                                  className="earn-points-link"
                                >Prize</a>

                                <a
                                  // href
                                  onClick={() => this.showStats()}
                                  className="earn-points-link"
                                >STATs</a>
                              </div>
                            </div>

                            {selectedMainTab == 1 && (
                              <Tab.Container
                                id="tabs-with-dropdown"
                                defaultActiveKey={
                                  selectedUserTab == 0 ? "general" : "pundits"
                                }
                                className="default-tab default-tab-two"
                              >
                                <Row className="clearfix">
                                  {selectedLeague.value == "1" && (
                                    <Col sm={12}>
                                      <Nav bsStyle="tabs shadow m-b-sm">
                                        <NavItem
                                          onClick={() => this.onTabUserClick(0)}
                                          eventKey="general"
                                        >
                                          General
                                        </NavItem>
                                        <NavItem
                                          onClick={() => this.onTabUserClick(1)}
                                          eventKey="pundits"
                                        >
                                          Pundits Only
                                        </NavItem>
                                      </Nav>
                                    </Col>
                                  )}
                                  <Col sm={12}>
                                    <Tab.Content animation>
                                      <Tab.Pane eventKey="general">
                                        {this.renderLeaderboardData()}
                                      </Tab.Pane>
                                      <Tab.Pane eventKey="pundits">
                                        {this.renderLeaderboardData()}
                                      </Tab.Pane>
                                    </Tab.Content>
                                  </Col>
                                </Row>
                              </Tab.Container>
                            )}
                          </div>
                        }
                      </Tab.Pane>
                      <Tab.Pane eventKey={2} className={`${selectedMainTab == 2 ? 'active in' : ''}`}>
                        {/* <div className="leaderboard-header">
                          <FormGroup className="input-label-center input-transparent font-14 m-b-sm"> */}

                        {/* <div className="filter">
                              <div className="filterStyle">
                                <Select
                                  onChange={this.handleFollowerChange}
                                  options={Constants.FollowOption}
                                  classNamePrefix="secondary"
                                  className="select-secondary minusML10"
                                  placeholder="Select Filter"
                                  isSearchable={false}
                                  isClearable={false}
                                  value={selectedFollowOption}
                                  theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    colors: {
                                      ...theme.colors,
                                      primary: "#37003C"
                                    }
                                  })}
                                />
                              </div>
                              <span className="select-arr">
                                <i className="icon-arrow-sort" />
                              </span>
                              <div className="gender-border col-sm-12" />
                            </div> */}
                        {/* </FormGroup>
                          </div> */}
                        {this.isRPLCupSelected() ? this.renderRPLCup() : this.renderRefLeague()}

                        {/* <ComingSoon /> */}
                      </Tab.Pane>
                      {/* <Tab.Pane   className={`${selectedMainTab == 3 ? 'active in' : ''}`}>
                        <ComingSoon />
                      </Tab.Pane> */}
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </div>
          </div>
        )
        }
      </MyContext.Consumer>
    );
  }
}
